import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { ENTRANT_DASHBOARD_PATH, JUDGE_DASHBOARD_PATH } from 'config';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AdminGuard = ({ children }) => {
    const { isLoggedIn, userType } = useAuth();
    const navigate = useNavigate();
    console.log('AuthGuard userType', userType);

    useEffect(() => {
        if (!isLoggedIn) {
            navigate('/login', { replace: true });
        } else if (userType === 'judge') {
            navigate(JUDGE_DASHBOARD_PATH, { replace: true });
        } else if (userType === 'entrant') {
            navigate(ENTRANT_DASHBOARD_PATH, { replace: true });
        }
    }, [isLoggedIn, navigate, userType]);

    return children;
};

AdminGuard.propTypes = {
    children: PropTypes.node
};

export default AdminGuard;
